import { render, staticRenderFns } from "./VidTextInput.vue?vue&type=template&id=049d0bc4"
import script from "./VidTextInput.vue?vue&type=script&lang=js"
export * from "./VidTextInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports